import { WisoryLabel } from 'components/Inputs';
import { Tag } from 'components/Tag';
import { TimeSlot, getTimeSpan } from 'components/TimeSlotPicker';
import dayjs from 'dayjs';
import { t } from 'i18next';

export const TimeSpanSection = ({ advisorName, timeslots }: { advisorName: string; timeslots: TimeSlot[] }) => {
  return (
    <div className="flex mb-5 sm:flex-row flex-col">
      <WisoryLabel className="sm:w-44 mr-3 sm:mb-0 mb-3">{t('REACT_BOOKING_FRONTEND.common.dateAndTime')}</WisoryLabel>
      <div className="sm:w-4/5 flex flex-col font-openSans">
        <div className="mb-4 flex flex-col gap-2">
          {timeslots
            .filter((s) => s.startDate && s.endDate)
            .map((s, index) => {
              return (
                <Tag className="text-black flex items-center sm:w-90 w-full" key={s.startDate?.getTime()}>
                  <b className="mr-1">
                    {t('customer_info_form_proposal')} {index + 1}:
                  </b>
                  <span>
                    {dayjs(s.startDate!).format('DD MMMM YYYY')},{' '}
                    {t(`customer_info_form_${getTimeSpan(s.startDate!, s.endDate!).toLowerCase()}`)}
                  </span>
                </Tag>
              );
            })}
        </div>
        <div className="text-xs text-black font-openSans">
          {t('REACT_BOOKING_FRONTEND.booking2.suggestionNotes', { advisorName })}
        </div>
      </div>
    </div>
  );
};
